export const VALIDATE_SEQUENCE = 'Valider';
export const RESTART_SEQUENCE = 'Recommencer';
export const CONTINUE_SEQUENCE = 'Continuer';
